import { render, staticRenderFns } from "./Agentminus.vue?vue&type=template&id=198ca13e&"
import script from "./Agentminus.vue?vue&type=script&lang=js&"
export * from "./Agentminus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports